import {isFunction} from '../../../../helpers'
import {roles} from '@eitje/bridge'

export function useAdvancedTableRoleMessage(cell) {
	const {enableRole} = cell.column.columnDef
	if (!enableRole) return

	return roles.useRoleMessage({roles: enableRole, env: figureOutEnvId(cell)})
}

function figureOutEnvId(cell) {
	const {roleEnv} = cell.column.columnDef

	if (!roleEnv) return null

	if (isFunction(roleEnv)) {
		const record = cell.getContext().row.original
		return roleEnv(record)
	}

	// may be an integer or array
	return roleEnv
}
